import { render, staticRenderFns } from "./UpdateForm.vue?vue&type=template&id=0cd9c465&scoped=true"
import script from "./UpdateForm.vue?vue&type=script&lang=js"
export * from "./UpdateForm.vue?vue&type=script&lang=js"
import style0 from "./UpdateForm.vue?vue&type=style&index=0&id=0cd9c465&prod&lang=scss&scoped=true"
import style1 from "./UpdateForm.vue?vue&type=style&index=1&id=0cd9c465&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd9c465",
  null
  
)

export default component.exports